/* istanbul ignore file */

window.thirdParties = true;
if (window.webpack_public_path) {
  __webpack_public_path__ = window.webpack_public_path;
}

import { Trace, Warn } from '@utilities/logging';
Trace(`🔧 Code version: ${process.env.IMAGE_VERSION}`);

import(/* webpackPreload: true */ './_thirdparties-core');

if (import.meta.webpackHot) import.meta.webpackHot.accept(Warn);
else if (module.hot) module.hot.accept(Warn);
